import { useNavigate } from "react-router-dom";
import { scrollToJoinSection } from "@/lib/scroll-to-join";

export default function HeroSection() {
  const navigate = useNavigate();

  function goToJoinForm() {
    if (scrollToJoinSection()) return;
    void navigate("/#join");
  }

  return (
    <section className="flex flex-col items-center text-center gap-5">
      <button
        type="button"
        onClick={() => goToJoinForm()}
        className="inline-block bg-white/5 border border-white/40 text-white/80 text-sm font-medium rounded-full px-4 py-1.5 animate-[fade-in_0.5s_ease-out] cursor-pointer hover:bg-white/10 transition-colors"
      >
        Free &middot; WhatsApp Community
      </button>

      <h1 className="font-fira-condensed text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight animate-[fade-in_0.5s_ease-out_0.1s_both]">
        Staying Ahead
      </h1>

      <h2 className="text-xl sm:text-2xl font-medium text-white/90 max-w-lg animate-[fade-in_0.5s_ease-out_0.2s_both]">
        Your unfair advantage in AI.
      </h2>

      <p className="text-secondary text-base sm:text-lg max-w-sm leading-relaxed animate-[fade-in_0.5s_ease-out_0.3s_both]">
        Skip the noise. Get the signal. AI updates, tools, and live sessions
        straight to{" "}
        <span className="flex justify-center items-center gap-1 text-white/90 mt-5">
          <svg
            className="w-4 h-4 sm:w-5 sm:h-5 text-white/90 inline"
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
          </svg>
          WhatsApp.
        </span>
      </p>

      {/* Founder */}
      <div className="flex items-center gap-2.5 animate-[fade-in_0.5s_ease-out_0.4s_both]">
        <img
          src="/vaibhav.png"
          alt="Vaibhav Sisinty"
          width={40}
          height={40}
          className="rounded-lg object-cover shrink-0 border border-white/10"
        />
        <div className="text-left">
          <p className="text-white text-sm font-medium leading-tight">
            Vaibhav Sisinty
          </p>
          <p className="text-secondary text-xs">Founder, GrowthSchool</p>
        </div>
      </div>

      {/* Scroll to form */}
      <button
        type="button"
        onClick={() => goToJoinForm()}
        className="mt-2 animate-[fade-in_0.5s_ease-out_0.5s_both] text-secondary/90 hover:text-white/60 transition-colors cursor-pointer rounded-full p-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/40"
        aria-label="Scroll to signup form"
      >
        <svg
          className="w-5 h-5 animate-bounce"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M6 9l6 6 6-6" />
        </svg>
      </button>
    </section>
  );
}
